// Penolong tampilan untuk kartu "Set Dicuci" di Laporan. Angkanya dihitung MESIN
// (backend: susun_set_dicuci); di sini hanya label dan urutan tampil.
const BULAN = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];

const urai = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!m) return null;
  return { y: +m[1], m: +m[2], d: +m[3] };
};

export const labelTanggal = (iso) => {
  const u = urai(iso);
  return u ? `${u.d} ${BULAN[u.m - 1]}` : String(iso || '-');
};

// "26 – 31 Okt", "28 Sep – 4 Okt", atau satu tanggal bila awal = akhir.
export const labelRentang = (a, b) => {
  const x = urai(a);
  const y = urai(b);
  if (!x || !y) return `${a || '-'} – ${b || '-'}`;
  if (a === b) return labelTanggal(a);
  if (x.y === y.y && x.m === y.m) return `${x.d} – ${y.d} ${BULAN[y.m - 1]}`;
  return `${labelTanggal(a)} – ${labelTanggal(b)}`;
};

export const slugKategori = (k) => String(k || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

// Data kosong / dari server lama (tanpa set_dicuci) = nol semua, tidak error.
export const rapikanSetDicuci = (sd) => ({
  total: Number(sd?.total) || 0,
  setelan: Number(sd?.setelan) || 0,
  bawahan_saja: Number(sd?.bawahan_saja) || 0,
  per_kategori: Array.isArray(sd?.per_kategori) ? sd.per_kategori : [],
  per_hari: Array.isArray(sd?.per_hari) ? sd.per_hari : [],
  per_minggu: Array.isArray(sd?.per_minggu) ? sd.per_minggu : [],
  lainnya_pcs: Number(sd?.lainnya_pcs) || 0,
});
